<template>
  <v-text-field
    v-bind="commonProps"
    v-model="numberValue"
    :filled="filled"
    type="number"
    :step="step"
    :min="min"
    :max="max"
    @input="pushUpdate"
  ></v-text-field>
</template>

<script>
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import Editable from '@ilteducation/vuetify-admin/src/mixins/editable';

/**
 * Optimized for number editing. Just a type number input with step, min and max attribute behavior.
 */
export default {
  mixins: [Input, Editable],
  props: {
    /**
     * Number to be edited.
     * @model
     */
    value: {
      type: Number,
      default: null,
    },
    /**
     * Number to be edited.
     * @model
     */
    valueNumber: {
      type: Number,
      default: null,
    },
    /**
     * Use full filled background color style.
     */
    filled: {
      type: Boolean,
      default: true,
    },
    /**
     * The interval step.
     */
    step: {
      type: Number,
      default: 1,
    },
    /**
     * The minimum accepted value.
     */
    min: Number,
    /**
     * The maximum accepted value.
     */
    max: Number,
  },
  data() {
    return {
      numberValue: Number(this.value),
    };
  },
  computed: {
    computedNumber: {
      get() {
        console.log('get value');
        return this.value;
      },
      set(newVal) {
        console.log(`set value ${Number(newVal)}`);
        this.$emit('change', Number(newVal));
      },
    },
  },
  watch: {
    value(newVal) {
      this.numberValue = newVal;
    },
  },
  mounted() {
    this.numberValue = Number(this.input);
    this.pushUpdate();
  },
  methods: {
    pushUpdate() {
      this.update(Number(this.numberValue));
    },
  },
};
</script>
